export default "__VITE_ASSET__BYwIweJu__"